import { EventEmitter } from '@angular/core';
import { systemValues } from '../../app.constants';
import { InfluencerService } from '../../services/influencer/influencer.service';
import { InfluencerIgStoryLoadingStatus } from '../../../models/influencer';
var AchooUserAvatarComponent = /** @class */ (function () {
    function AchooUserAvatarComponent(influencerService) {
        this.influencerService = influencerService;
        this.afterImageLoaded = new EventEmitter();
        this.isLoadingImage = true;
    }
    AchooUserAvatarComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.showIgLoader) {
            this.igStoryLoadingSubscription = this.influencerService.loadingNewStoriesEvent.subscribe(function (newStatus) {
                _this._igStoryLoadingStatus = newStatus;
            });
        }
    };
    AchooUserAvatarComponent.prototype.ngOnDestroy = function () {
        if (this.igStoryLoadingSubscription) {
            this.igStoryLoadingSubscription.unsubscribe();
        }
    };
    AchooUserAvatarComponent.prototype.resolveNoAvatarUrl = function () {
        this.userAvatarPicture = systemValues.defaultUserAvatarPicture;
    };
    AchooUserAvatarComponent.prototype.onLoadedImage = function () {
        this.isLoadingImage = false;
        this.afterImageLoaded.emit(true);
    };
    AchooUserAvatarComponent.prototype.calculateTopPosition = function () {
        if (this.isTopCountryFlag) {
            return 0.3125;
        }
        else {
            return (this.avatarHeight - this.countryHeight) / 2 + 0.1;
        }
    };
    AchooUserAvatarComponent.prototype.calculateLeftPosition = function () {
        if (this.isTopCountryFlag) {
            return this.avatarWidth - (this.countryWidth / 2) - 0.25;
        }
        else {
            return this.avatarWidth - (this.countryWidth / 2) + 0.25;
        }
    };
    Object.defineProperty(AchooUserAvatarComponent.prototype, "isLoadingNewStories", {
        get: function () {
            return this._igStoryLoadingStatus && this._igStoryLoadingStatus === InfluencerIgStoryLoadingStatus.PROCESSING;
        },
        enumerable: true,
        configurable: true
    });
    return AchooUserAvatarComponent;
}());
export { AchooUserAvatarComponent };



// WEBPACK FOOTER //
// ./src/app/core/achoo-user-avatar/achoo-user-avatar.component.ts.pre-build-optimizer.js